import axios from "axios";
import { UserPermissions } from "../Models/Permission";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const getUserPermissions = async (token: string | null): Promise<UserPermissions> => {

  try {
    const response = await axios.get<UserPermissions>(
      `${API_BASE_URL}/rbac/permission`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching user permissions:", error);
    throw error;
  }
};